/*eslint-disable*/module.exports={messages:{"© Pipelyne all rights reserved":"© Pipelyne all rights reserved"}};